import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  inputContainer: {
    marginBottom: 20,
  },
  categories: {
    marginTop: 10,
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 12,
  },
  filtersContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
  },
  filter: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    marginRight: 10,
  },
  iconContainer: {
    position: 'relative',
    width: 30,
    height: 24,
  },
  filterIcon: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
  },
  badge: {
    position: 'absolute',
    top: -6,
    right: -8,
    backgroundColor: Colors.RedPallete.red || 'darkred',
    borderRadius: 10,
    minWidth: 16,
    height: 16,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
  },
  badgeText: {
    color: 'white',
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    textAlign: 'center',
    lineHeight: 14,
  },
  products: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  textBuy: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 18,
    maxWidth: 180,
    marginTop: 5,
    marginBottom: 20,
    color: Colors.GrayPallete.lightgrayThree,
  },
  space: {
    marginBottom: 100,
  },
  columnFlat: {
    justifyContent: 'space-between',
  },
  notFoundProduct: {
    fontSize: 14,
    fontWeight: '500',
    color: 'darkblue',
  },
  featuredButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Colors.RedPallete.red,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginVertical: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  starIcon: {
    width: 20,
    height: 20,
    marginRight: 10,
    tintColor: 'white',
  },
  featuredText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'white',
    lineHeight: 19,
  },
  offersCTAWrapper: {
    marginTop: 12,
    marginBottom: 4,
    borderRadius: 14,
    overflow: 'hidden',
    shadowColor: '#DD0B1C',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
  offersCTAGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 14,
    paddingHorizontal: 16,
  },
  offersCTALeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  offersCTABadge: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'rgba(255,255,255,0.25)',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  offersCTABadgeText: {
    fontSize: 18,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'white',
    lineHeight: 22,
  },
  offersCTATitle: {
    fontSize: 15,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'white',
    lineHeight: 19,
  },
  offersCTASubtitle: {
    fontSize: 11,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'rgba(255,255,255,0.85)',
    lineHeight: 15,
    marginTop: 1,
  },
  offersCTAArrow: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: 'rgba(255,255,255,0.2)',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
  },
  offersCTAArrowText: {
    fontSize: 22,
    color: 'white',
    lineHeight: 26,
    marginTop: -2,
  },
});